var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130px",
    height: "31px",
    viewBox: "0 0 130 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-contracts",
    transform: "translate(-7.000000, -11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HEADER"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(7.500000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    stroke: "#C350ED",
    x: 0.719351611,
    y: -0.356939387,
    width: 29.4350814,
    height: 29.6121227,
    rx: 1.95999988
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-32-Copy",
    fill: "#EB4DFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31-Copy",
    transform: "translate(14.491788, 14.276064) rotate(-315.000000) translate(-14.491788, -14.276064) translate(3.813822, 5.118169)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    transform: "translate(10.663156, 9.012819) rotate(-270.000000) translate(-10.663156, -9.012819) ",
    points: "1.7933975 6.88018753 1.7933975 11.1454497 19.5329136 11.1454497 19.5329136 6.88018753"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    x: -4.36557457e-11,
    y: 4.00569717,
    width: 4.26526221,
    height: 8.5836368
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    x: 17.0610488,
    y: 4.00569717,
    width: 4.26526221,
    height: 8.5836368
  })))), /*#__PURE__*/React.createElement("text", {
    id: "neoscan",
    fontSize: 19.9999988,
    fontWeight: 300,
    letterSpacing: 2.13935447,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 37,
    y: 24
  }, "dora"))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile-logo.161aa018.svg";
export { ForwardRef as ReactComponent };